import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { DropDownTitleComponent } from "../components/drop-down-title/drop-down-title";

@NgModule( {
               declarations: [
                   MyApp,
                   HomePage,
                   DropDownTitleComponent
               ],
               imports: [
                   BrowserModule,
                   IonicModule.forRoot( MyApp )
               ],
               bootstrap: [IonicApp],
               entryComponents: [
                   MyApp,
                   HomePage
               ],
               providers: [
                   StatusBar,
                   SplashScreen,
                   { provide: ErrorHandler, useClass: IonicErrorHandler }
               ]
           } )
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts